import React, { Component } from 'react';
import withStyles from '@mui/styles/withStyles';
import {
    ExclamationCircleIcon,
    ExclamationTriangleIcon,
    FireIcon,
    InfoCircleIcon,
    QuestionMarkCircleIcon,
    TickCircleIcon
} from '../IconIndex';

class AlertBar extends Component {
    render() {
        const { variant, style, children } = this.props;
        return (
            <div className={`alert-bar alert-bar--${variant}`} style={style}>
                {this.renderIcon()}
                <div className="content">{children}</div>
            </div>
        );
    }

    renderIcon() {
        const { variant } = this.props;
        if (variant === 'info')
            return <InfoCircleIcon />;
        if (variant === 'success')
            return <TickCircleIcon />;
        if (variant === 'warning')
            return <ExclamationTriangleIcon />;
        if (variant === 'error')
            return <ExclamationCircleIcon />;
        if (variant === 'attention')
            return <QuestionMarkCircleIcon />;
        if (variant === 'fire')
            return <FireIcon />;

        // eslint-disable-next-line no-console
        console.error('unknown variant ' + variant);
        return <b>Unknown variant {variant}</b>;
    }
}

export default withStyles({})(AlertBar);
